import { useState } from "react";
import { makeStyles } from "tss-react/mui";
import { MiTab } from "@miplatform/components";
import { Box } from "@mui/material";
import {
  ACCOUNT_PRICING_TABS_VALUE,
  SELECTED_PRICING_TABS,
} from "../../constants";
import { PriceDistributionTab } from "./PriceDistributionTab/PriceDistributionTab";

export function CategoryPricing({
  setCalculationType,
  selectedCategory,
  accountDetail,
  getValues,
  setValue,
  control,
}) {
  const [activeTab, setActiveTab] = useState(
    ACCOUNT_PRICING_TABS_VALUE.PRICE_AND_DISTRIBUTION
  );
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <MiTab
        tabs={[SELECTED_PRICING_TABS()[0]]}
        currentTab={activeTab}
        onTabChange={setActiveTab}
        scrollButtons={false}
        borderBottom
      />
      {activeTab === ACCOUNT_PRICING_TABS_VALUE.PRICE_AND_DISTRIBUTION && (
        <PriceDistributionTab
          setCalculationType={setCalculationType}
          selectedCategory={selectedCategory}
          accountDetail={accountDetail}
          getValues={getValues}
          setValue={setValue}
          control={control}
        />
      )}
    </Box>
  );
}

const useStyles = makeStyles()(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    margin: 4,
    overflowY: "auto",
  },
}));
